const URL_BASE = process.env.REACT_APP_API_URL;
// const URL_BASE = 'https://3f20-200-34-165-190.ngrok-free.app';

export const CPB_URL = `${URL_BASE}/centralSimac`;
